import { Box, SvgIcon } from "@mui/material";
import { ReactNode } from "react";
import { translations } from "translations";
import {
  StyledFooterCopyrightBox,
  StyledFooterInfo,
  StyledFooterInfoBox,
  StyledFooterInfoBoxWrapper,
  StyledFooterInfoContentWrapper,
  StyledFooterInfoWrapper,
} from "./styles";

export interface ElementItem {
  icon?: React.ReactNode;
  text?: string;
  withLink?: { to: string; label: string };
}

export interface FooterInfoItems {
  headerTitle: ReactNode;
  content: Array<ElementItem>;
  width?: string;
}

export type FooterInfoBoxContentProps = Array<FooterInfoItems>;

export type FooterInfoBoxElementItemFooterInfoBoxContentProps = Omit<FooterInfoItems, "headerTitle">;

const FooterInfoBoxElementItem = ({ content, width }: FooterInfoBoxElementItemFooterInfoBoxContentProps) => (
  <StyledFooterInfoContentWrapper>
    {content.map((item, index) => (
      <StyledFooterInfo key={index} width={width}>
        {item.icon && item.text && <SvgIcon>{item.icon}</SvgIcon>}
        {item.icon && !item.text && <>{item.icon}</>}
        {!item.withLink && item.text}
        {item.withLink && (
          <Box flexDirection="column">
            <Box dangerouslySetInnerHTML={{ __html: item.text ?? "" }} />
            <Box>
              <a href={item.withLink.to}>{item.withLink.label}</a>
            </Box>
          </Box>
        )}
      </StyledFooterInfo>
    ))}
  </StyledFooterInfoContentWrapper>
);

const FooterInfoBoxElement = ({
  element,
}: {
  element: {
    headerTitle: ReactNode;
    content: Array<ElementItem>;
    width?: string;
    margin?: string | number;
  };
}) => {
  return (
    <StyledFooterInfoBox margin={element.margin}>
      <StyledFooterInfoWrapper fontWeight={400}>{element.headerTitle}</StyledFooterInfoWrapper>
      <StyledFooterInfoWrapper fontWeight={400}>
        <FooterInfoBoxElementItem content={element.content} width={element.width} />
      </StyledFooterInfoWrapper>
    </StyledFooterInfoBox>
  );
};

export const FooterInfoBoxContent = ({
  content,
  FooterMiddlePart,
}: {
  content: FooterInfoBoxContentProps;
  FooterMiddlePart: JSX.Element;
}) => (
  <StyledFooterInfoBoxWrapper role="contentinfo">
    <>
      <StyledFooterCopyrightBox>{translations.globals.footer.copyrightString}</StyledFooterCopyrightBox>
      {FooterMiddlePart}
      {content.map((element, index) => (
        <FooterInfoBoxElement key={index} element={element} />
      ))}
    </>
  </StyledFooterInfoBoxWrapper>
);
